// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipWrapper_tooltip__mDnLg"};